export default () => ({
  all: null,
  current: null,
  sort: 'model',
  filter: {
    query: '',
    model: '',
  },
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
  },
});
